import React, { useContext, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";

import { domain } from "../../services/constants";
import "./activityTypes.css";

import { fetchActivityTypes } from "../../services/activity";

import "swiper/css";
import "swiper/css/scrollbar";
import useWindowDimensions from "../../hooks/useWindowDimensions";
import { showVideoModalActive } from "../../redux/slices/activityCategories";
import { updateActivityTypes } from "../../redux/slices/activityTypes";
import { setDefaultSelectedActivity } from "../../redux/slices/userActivity";
import ActivityType from "./activityType";

//activity types slider in home page
export default function ActivityTypes() {
  const { activityTypes } = useSelector((state) => state.activityTypes);
  const { categories } = useSelector((state) => state.activityCategories);
  const { defaultSelectedActivity } = useSelector((state) => state.userActivity);
  const { isLoggedIn } = useSelector((state) => state.user);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { width } = useWindowDimensions();

  useEffect(() => {
    fetchActivityTypes((err, res) => {
      if (err) return;
      let tempTypes = res.data.map((type) => {
        return { ...type, isSelected: true, subtypes: [] };
      });
      dispatch(updateActivityTypes(tempTypes));
    });
  }, []);

  const selectedCategory = categories.find((category) => category.isSelected === true);
  const selectedTypes = activityTypes.filter((type) => type.activity_category_id === selectedCategory.id);

  const handleClick = (type) => {
    if (!type.activity_category_id) return;
    // if (type.activity_category_id.name.toLowerCase().includes("video")) {
    //   dispatch(showVideoModalActive());
    // } else {
    // }
    // if (!isLoggedIn) return window.open(`/design?selectedActivityId=${type.id}`, "_blank");

    navigate(`/design?selectedActivityId=${type.id}`);
  };

  return (
    <div className="activity_types">
      <Swiper className="activity_types__slider" slidesPerView={width <= 1275 ? "auto" : 4} spaceBetween={15} slidesPerGroup={2}>
        {selectedTypes.length === 0 ? (
          <div>
            <SwiperSlide className="swiper_slide template">
              <ActivityType />
            </SwiperSlide>
            <SwiperSlide className="swiper_slide template">
              <ActivityType />
            </SwiperSlide>
            <SwiperSlide className="swiper_slide template">
              <ActivityType />
            </SwiperSlide>
            <SwiperSlide className="swiper_slide template">
              <ActivityType />
            </SwiperSlide>
            <SwiperSlide className="swiper_slide template">
              <ActivityType />
            </SwiperSlide>
          </div>
        ) : (
          selectedTypes.map((type) => {
            return (
              <SwiperSlide key={type.id} className="swiper_slide" onClick={() => handleClick(type)}>
                {/* {type.notificationTag && <div className="notification-tag">Try</div>} */}
                <ActivityType {...type} isTemplate={true} />
              </SwiperSlide>
            );
          })
        )}
      </Swiper>
    </div>
  );
}
